export default {
  getSlides(state) {
    return state.slides
  },
}
